import React, { useEffect, useState } from "react";
import { Header } from "../../components";
import { StandingsRespone, useEsportsAPI } from "../../hooks";

export function StandingsPage() {
  const [standings, setStandings] = useState<StandingsRespone>({})
  const {getStandings} = useEsportsAPI()

  useEffect(() => {
    getStandings().then((res) => res.data).then((data) => setStandings(data))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const parseData = () => {
    const elements = []
    if (standings.data) {
      for (let i = 0; i < standings.data.length; i++) {
        const groupData = standings.data[i]
        const groupName = Object.keys(groupData)[0]
        const groupDetails = groupData[groupName]
        const headings = groupDetails[0]
        const playerDetails = groupDetails.slice(1)
        elements.push(
          <>
          <h2>{groupName}</h2>
          <table>
            <thead>
              <tr>
              {headings.map((item) => <th>{item}</th>)}
              </tr>
            </thead>
            <tbody>
              {playerDetails.map((player) => (
                <tr>
                  {player.map((item) => <td>{item}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
          </>
        )
      }
    }
    return elements 
  }

  return (
    <div className="container">
      <Header title="Standings" />
      {parseData()}
    </div>
  );
}
